export const environment = {
    production: true,
    demoMode: false,
    apiurl: 'https://app-matchingcopilot-001-devt.azurewebsites.net/api',
    msal: "/msal.devt.config.json"
};